import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { AutenticacionService } from './autenticacion.service';
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import { ValidityEmployees } from '../_models/vigencias';

@Injectable({
    providedIn: 'root'
})
export class ValidityEmployeesService {

  serviceURL = AppSettings.rutServiciosTER + '/api/vigenciasTerceros';

  constructor( private authHttp: HttpClient, private authenticationService: AutenticacionService ) {
  }

  getAll() {
     return this.authHttp.get( this.serviceURL ).pipe( map( res => res as ValidityEmployees[] ) );
  }

  getAllEnable() {
     return this.authHttp.get( this.serviceURL + '/enabled' ).pipe( map( res => res as ValidityEmployees[] ) );
  }

  getById( id: string ) {
     return this.authHttp.get( this.serviceURL + '/' + id  ).pipe( map( res => res as ValidityEmployees ) );
  }

  add( c: ValidityEmployees ) {
     c.auditoriaUsuario = this.authenticationService.obtenerIdUsuarioLogueado();
     c.auditoriaUsuarioSistema = this.authenticationService.obtenerIdUsuarioLogueado();
     return this.authHttp.post( this.serviceURL, c ).pipe( map( res => res as ValidityEmployees ) );
  }

  update( c: ValidityEmployees ) {
     c.auditoriaUsuario = this.authenticationService.obtenerIdUsuarioLogueado();
     c.auditoriaUsuarioSistema = this.authenticationService.obtenerIdUsuarioLogueado();
     return this.authHttp.put( this.serviceURL , c ).pipe( map( res => res as ValidityEmployees ) );
  }
}
